var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"[ text-h4  text-weight-bolder  text-white  text-center ]  [ q-pa-none  q-pb-lg  q-my-none  q-mx-auto ]"},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }